import React from "react";
import styles from "./CardHero.module.css";

const CardHero = ({
    imageSrc,
    logoSrc,
    mainText,
    date,
    buttonText,
    buttonLink,
    backTitle,
    backText
}) => {
    return (
        <div className={styles.cardContainer}>
            <div className={styles.cardInner}>
                <div className={styles.cardFront}>
                    <img src={imageSrc} alt="Hero" className={styles.image} />
                    <div className={styles.text}></div>
                    <div className={styles.logo}>
                        <img src={logoSrc} alt="Logo" />
                    </div>
                    <div className={styles.maintext}>
                        <h2>{mainText}</h2>
                    </div>
                    <div className={styles.date}>
                        <p>{date}</p>
                    </div>
                </div>

                <div className={styles.cardBack}>
                    <h2 className={styles.Cardh2p}>{backTitle}</h2>
                    <p className={styles.Cardh2p}>{backText}</p>
                    <div className={styles.herobtn}>
                        <a href={buttonLink}>{buttonText}</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardHero;
